import { Button } from '@design-system/components/button/button';
import { Typography } from '@design-system/components/typography/typography';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router';
import { PaidProgramGuide } from './paidProgramsGuide';
import { EmptyStateGuideInfo } from './emptyStateGuideInfo';

export type OtpEmptyStateProps = {
  isGuideOpen: boolean;
  closeGuide: () => void;
  openGuide: () => void;
  to: string;
  name: string;
  guideLink: string;
};

export const OtpEmptyState = ({
  to,
  isGuideOpen,
  closeGuide,
  openGuide,
  name,
  guideLink,
}: OtpEmptyStateProps) => (
  <div className="w-full h-full flex flex-col">
    <EmptyStateGuideInfo
      name={name}
      type="Paid programs"
      guideLink={guideLink}
    />
    <div className="flex flex-col w-full h-full justify-center items-center">
      <div className="flex flex-col justify-center gap-2">
        <Typography variant="headline" className="text-center">
          Your programs will be shown here
        </Typography>
        <Typography
          variant="body"
          size="large"
          className="text-[#646464] text-center"
        >
          Create your first paid program and start selling faster!
        </Typography>
      </div>
      <Link
        to={to}
        className="w-[180px] bg-black text-white rounded-[10px] mt-6 mb-8"
      >
        <Typography className="text-center px-4 py-2">
          <FontAwesomeIcon icon={faPlus} className="pr-2" /> Create
        </Typography>
      </Link>
      <div className="flex flex-col justify-center gap-2">
        <Typography className="text-center">
          Learn how to create a program that sells.
        </Typography>
        <Button variant="text" onClick={openGuide}>
          Guide
        </Button>
        <PaidProgramGuide isOpen={isGuideOpen} close={closeGuide} />
      </div>
    </div>
  </div>
);
